import { fromJS } from 'immutable';
import omit from 'lodash/omit';
import { BusinessQuery } from '@/modules/dashboard/dashboardTypes';

const resetQueryPartial = (
	query: BusinessQuery,
	partialQuery: Partial<BusinessQuery>
): Partial<BusinessQuery> => {
	const queryNew: BusinessQuery = fromJS(query).toJS();

	const queriesToRemove = Object.keys(partialQuery);

	return omit(queryNew, queriesToRemove);
};

export default resetQueryPartial;
